export const createRequestHeadersConfig = (
  token?: string,
  otherHeaders?: Record<string, string>
) => {
  if (token) {
    return {
      headers: {
        Authorization: `Bearer ${token}`,
        ...otherHeaders
      }
    }
  }

  return {
    headers: {
      ...otherHeaders
    }
  }
}
